import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnChanges, Output } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { AdjDefLabelPipe, CommaListPipe, DatetimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";
import { ActionButtonComponent } from "../action-button/action-button.component";

@Component({
	selector: "app-adjustment-history",
	imports: [AdjDefLabelPipe, CommaListPipe, DatetimePipe, ActionButtonComponent],
	templateUrl: "./adjustment-history.component.html",
	styleUrl: "./adjustment-history.component.scss",
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AdjustmentHistoryComponent implements OnChanges {
	api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	public rotor: APIResults.Rotor;
	@Input()
	public adjustments: APIResults.AdjustmentHistory[]
	@Output()
	adjustmentDeleted = new EventEmitter();
	@Output()
	createBaseline = new EventEmitter();

	public adjustmentSums: string[];
	public blades: string;
	public baseline: APIResults.AdjustmentBaseline;
	public isH60: boolean;

	async ngOnChanges() {
		this.adjustmentSums = undefined;
		if (this.adjustments && this.adjustments.length > 0) {
			this.blades = this.rotor.blade.map(item => item.name).join(", ");
			this.baseline = await this.api.GetAdjustmentBaseline(this.asset.asset_id, this.rotor.rotorid);
			this.isH60 = this.rotor.balancedata.shaftbalance?.toUpperCase() === "H60";
			if (!this.isH60) {
				this.adjustmentSums = DvsUtilities.SumAdjustments(this.adjustments, this.baseline);
			}
		}
	}

	async DeleteAdjustment(id: number) {
		await this.api.DeleteAdjustment(this.asset.asset_id, id);
		this.adjustmentDeleted.emit();
	}

	async CreateBaseline() {
		this.createBaseline.emit();
	}

	async DeleteBaseline() {
		await this.api.DeleteAdjustmentBaseline(this.asset.asset_id, this.rotor.rotorid);
		this.baseline = undefined;
	}
}
